module.exports = __webpack_public_path__ + "assets/img/rz4.92aff6da.png";